export default __webpack_public_path__ + "static/media/info.576b1cbd.svg";